import { AlertConfigResponse } from "../../../../../types/Alerts/AlertTypes";

export const defaultAlertConfig: AlertConfigResponse = {
  unit_id: "",
  // pace_device_serial_number: "",
  site_alerts: {
    demand_response: { enabled: false },
    loss_connection: { enabled: false },
  },
  unit_alerts: [],
  reminder_recipients: [
    { reminders: "", email: "", phone_number: { country_code: "", base: "" } },
    { reminders: "", email: "", phone_number: { country_code: "", base: "" } },
    { reminders: "", email: "", phone_number: { country_code: "", base: "" } },
  ],
};
